var map = {
	"./arrow-right.svg": "dxdv",
	"./bjgl.svg": "Dohm",
	"./border-style.svg": "MLIY",
	"./bsgl.svg": "aigD",
	"./button.svg": "NHTG",
	"./cascader.svg": "2VtW",
	"./checkbox.svg": "LHos",
	"./cloud.svg": "Yvcf",
	"./color.svg": "fnP5",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./date-range.svg": "yBtI",
	"./date.svg": "Ve8B",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./file-diff-fill.svg": "Hj8j",
	"./gwgl.svg": "1scm",
	"./input.svg": "k6mQ",
	"./jxgl.svg": "MuyZ",
	"./lltk.svg": "RZK0",
	"./lsgl.svg": "tS+o",
	"./ltgl.svg": "H0Wl",
	"./lzgl.svg": "xz1T",
	"./number.svg": "tyP3",
	"./password.svg": "QjmH",
	"./people-fill.svg": "+UiX",
	"./radio.svg": "l4Qn",
	"./rate.svg": "h/JX",
	"./rich-text.svg": "44Gy",
	"./row.svg": "CPNK",
	"./select.svg": "FK+b",
	"./sjtj.svg": "2jt8",
	"./slider.svg": "rMcP",
	"./sparktk.svg": "gr9i",
	"./stickies-fill.svg": "g3hv",
	"./switch.svg": "qyXC",
	"./table.svg": "oSYw",
	"./textarea.svg": "zlq4",
	"./time-range.svg": "6py6",
	"./time.svg": "RJM1",
	"./upload.svg": "P/TB",
	"./wdzq.svg": "k0R9",
	"./xsgl.svg": "/0op",
	"./xtsz.svg": "jkuN",
	"./yhgl.svg": "RvI3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 61